import React from 'react';
import Layout from '../components/common/Layout';
import Dashboard from '../components/dashboard/Dashboard';

const DashboardPage = () => {
    return (
        <Layout>
            <Dashboard />
        </Layout>
    );
};

export default DashboardPage;